/**
* 系统管理 用户管理
*/
<template>
	<div>
		<!--列表-->
		<el-table size="small" :data="userData" highlight-current-row
			v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column align="center" sortable prop="deptName" label="id" width="120">
			</el-table-column>
			<el-table-column align="center"  prop="userName" label="姓名" width="120">
			</el-table-column>
			<el-table-column align="center"  prop="userMobile" label="电话号码" width="120">
			</el-table-column>
			<el-table-column align="center"  prop="editTime" label="角色" min-width="120">
			</el-table-column>
			<el-table-column label="操作" min-width="300">
				<template slot-scope="scope">
					<el-button size="mini" type="danger"
						@click="deleteUser(scope.$index, scope.row)">删除</el-button>
					<el-button size="mini" type="success"
						@click="resetpwd(scope.$index, scope.row)">重置密码</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-button @click="handleEdit()">添加人员</el-button>
		<!-- 编辑界面 -->
		<el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
			<el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
				<el-form-item label="姓名" prop="userRealName">
					<el-input size="small" v-model="editForm.userRealName" auto-complete="off" placeholder="请输入姓名" />
				</el-form-item>
				<el-form-item label="角色" prop="roleId">
					<el-select size="small" v-model="editForm.roleId" placeholder="请选择" class="userRole">
						<el-option label="管理员" value="4" />
						<el-option label="普通用户" value="0" />
					</el-select>
				</el-form-item>
				<el-form-item label="手机号" prop="userMobile">
					<el-input size="small" v-model="editForm.userMobile" placeholder="请输入手机号" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click='closeDialog("edit")'>取消</el-button>
				<el-button size="small" type="primary" :loading="loading" class="title"
					@click="submitForm('editForm')">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	// 导入请求方法
	import COS from 'cos-js-sdk-v5'
	import {
		GetCompanyUserList,
		SubmitUserSave,
		DeleteTheComUser,
		ReSetTheComUserKey
	} from '../../api/userMG'
	import Pagination from '../../components/Pagination'
	var prop = ["常规用户", "", "", "", "管理员"]
	export default {
		data() {
			return {
				loading: false, //是显示加载
				title: '添加用户',
				editFormVisible: false, //控制编辑页面显示与隐藏
				dataAccessshow: false, //控制数据权限显示与隐藏
				unitAccessshow: false, //控制所属单位隐藏与显示
				// 编辑与添加
				editForm: {
					userId: '',
					userName: '',
					userRealName: '',
					roleId: '',
					userMobile: '',
					userEmail: '',
					userSex: '',
					token: localStorage.getItem('logintoken')
				},
				// rules表单验证
				rules: {
					userRealName: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					roleId: [{
						required: true,
						message: '请选择角色',
						trigger: 'blur'
					}],
					userMobile: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
							required: true,
							message: '请输入正确的手机号',
							trigger: 'blur'
						}
					]
				},
				userData: []
			}
		},
		created() {
			this.loading = true
			var data = []
			GetCompanyUserList(0).then(res => {
				if (res.length) {
					res.forEach(e => {
						data.push({
							deptName: e[0],
							userName: e[2],
							userMobile: e[1],
							editTime: prop[e[3]]
						})
					})

				}
			})
			this.loading = false
			this.userData = data
		},
		methods: {
			//显示编辑界面
			handleEdit: function(index, row) {
				this.editFormVisible = true
				this.title = '添加用户'
				this.editForm.userRealName = ''
				this.editForm.roleId = ''
				this.editForm.userMobile = ''
			},
			// 编辑、添加提交方法
			submitForm(editData) {
				this.$refs[editData].validate(valid => {
					if (valid) {
						for(var i=0;i<this.userData.length;i++){
							if(this.userData[i].userMobile==this.editForm.userMobile){
								this.$message({
									type: 'info',
									message: '电话号码是登录账户，已存在！'
								})
								return false
							}
						}
						SubmitUserSave({
								t: 0,
								n: this.editForm.userRealName,
								r: this.editForm.roleId,
								p: this.editForm.userMobile
							})
							.then(res => {
								this.editFormVisible = false
								this.loading = false
								if (res) {
									this.$message({
										type: 'success',
										message: '数据保存成功！'
									})
									this.userData.push({
										deptName: res,
										userName: this.editForm.userRealName,
										userMobile: this.editForm.userMobile,
										editTime: prop[this.editForm.roleId]
									})
								} else {
									this.$message({
										type: 'info',
										message: '保存失败！'
									})
								}
							})
					} else {
						return false
					}
				})
			},
			// 关闭编辑、增加弹出框
			closeDialog(dialog) {
				if (dialog == 'edit') {
					this.editFormVisible = false
				} else if (dialog == 'perm') {
					this.dataAccessshow = false
				} else if (dialog == 'unit') {
					this.unitAccessshow = false
				}
			},
			// 删除用户
			deleteUser(index, row) {
				this.$confirm('确定要删除吗?', '信息', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						// 删除
						DeleteTheComUser(row.deptName)
							.then(res => {
								if (res) {
									this.$message({
										type: 'success',
										message: '数据已删除!'
									})
									this.userData.splice(index,1)
								} else {
									this.$message({
										type: 'info',
										message: res.msg
									})
								}
							})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除！'
						})
					})
			},
			// 重置密码
			resetpwd(index, row) {
				this.$confirm('确定要重置密码吗?', '信息', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						ReSetTheComUserKey(row.deptName,'0')
							.then(res => {
								if (res) {
									this.$message({
										type: 'success',
										message: '重置密码成功！'
									})
								} else {
									this.$message({
										type: 'info',
										message: '操作失败'
									})
								}
							})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '取消重置密码！'
						})
					})
			}
		}
	}
</script>
<style scoped>
	.user-search {
		margin-top: 20px;
	}

	.userRole {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/views/school/user.vue